import { render, staticRenderFns } from "./wtScrollableHorizontal.component.vue?vue&type=template&id=e69cb352&"
import script from "./wtScrollableHorizontal.component.vue?vue&type=script&lang=js&"
export * from "./wtScrollableHorizontal.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports